import api from './api';

export interface SurveyQuestion {
  id: string;
  type: 'numeric' | 'text' | 'single-choice' | 'multiple-choice' | 'pain-scale' | 'consent';
  question: string;
  helperText?: string;
  placeholder?: string;
  options?: Record<string, string>;
  labels?: {
    min?: string;
    max?: string;
  };
  consentItems?: Record<string, {
    label: string;
    description: string;
  }>;
  required: boolean;
  min?: number;
  max?: number;
  step?: number;
  multiline?: boolean;
  maxLength?: number;
  maxSelections?: number;
  variant?: string;
  hasNextButton?: boolean;
}

export interface SurveySessionResponse {
  question?: SurveyQuestion;
  currentIndex?: number;
  totalQuestions?: number;
  hasAnswer?: boolean;
  existingAnswer?: any;
  canGoBack?: boolean;
  canGoForward?: boolean;
  isComplete: boolean;
  surveyId: string;
  surveyTitle?: string;
  surveyDescription?: string;
  clinicName?: string;
  completedAt?: string;
  progress?: {
    current: number;
    total: number;
    answered: number;
  };
}

export interface SurveyCompletionData {
  surveyId: string;
  organizationName: string;
  clinicName: string;
  completedAt: string;
  language: string;
}

class SurveyService {
  async getSession(surveyId: string): Promise<SurveySessionResponse> {
    const response = await api.get(`/api/v1/survey/session/${surveyId}`);
    return response.data;
  }

  async submitAnswer(surveyId: string, questionId: string, answer: any, questionIndex: number): Promise<SurveySessionResponse> {
    const response = await api.put('/api/v1/survey/answer', {
      surveyId,
      questionId,
      answer,
      questionIndex
    });
    return response.data;
  }

  async getQuestionByIndex(surveyId: string, index: number): Promise<SurveySessionResponse> {
    const response = await api.get(`/api/v1/survey/session/${surveyId}/question/${index}`);
    return response.data;
  }

  async getCompletionData(surveyId: string): Promise<SurveyCompletionData> {
    const response = await api.get(`/api/v1/survey/session/${surveyId}/completion`);
    return response.data;
  }

  async createSurvey(data: {
    caseId: string;
    patientId: string;
    visitDate?: string;
    clinicName?: string;
    language?: string;
  }): Promise<{
    success: boolean;
    surveyId: string;
    surveyUrl: string;
    totalQuestions: number;
  }> {
    const response = await api.post('/api/v1/survey/create', data);
    return response.data;
  }
}

export default new SurveyService();